/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React, { forwardRef } from 'react';
import { Help as Nav4Help } from '@atlaskit/navigation-system/top-nav-items/help';
import type { HelpProps } from '@atlaskit/atlassian-navigation/help/types';
import type { BaseIconButtonProps } from '@atlaskit/atlassian-navigation/icon-button/types';

// Should this live in the migration layer (@jira/design-system__navigation-system) instead?
export const Help: React.ForwardRefExoticComponent<
	BaseIconButtonProps & {
		badge?: React.ComponentType<{}>;
	} & React.RefAttributes<HTMLButtonElement>
> = forwardRef<HTMLButtonElement, HelpProps>((props, ref) => {
	const { badge, onClick, isSelected, label } = props;
	return (
		<Nav4Help badge={badge} label={label} onClick={onClick} isSelected={isSelected} ref={ref} />
	);
});
